import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { ButtonAvailabilityResponse } from '../types';

export const modernizationButtonVisibilityApi = createApi({
  reducerPath: 'modernizationButtonVisibilityApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.API_URL}`,
    headers: {
      'Content-Type': 'application/json; charset=utf-8',
    },
  }),
  endpoints: (builder) => ({
    getModernizationButtonVisibility: builder.query<ButtonAvailabilityResponse, { exposeId: string, lastModificationDate?: string }>({
      query: (args) => {
        const { exposeId, lastModificationDate } = args;
        let url = `/modernisierungsrechner/expose/v1/availability?exposeId=${exposeId}&source=WEB`;
        if (lastModificationDate) {
          url += `&lastModificationDate=${lastModificationDate}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
    }),
  }),
});

export const { useGetModernizationButtonVisibilityQuery, useLazyGetModernizationButtonVisibilityQuery } =
  modernizationButtonVisibilityApi;
